(function() {
    'use strict';

    // Fuzzy search function using Levenshtein distance
    function fuzzySearch(searchTerm, text) {
        if (!text) return 0;
        
        const search = searchTerm.toLowerCase();
        const target = text.toLowerCase();
        
        // Exact match gets highest score
        if (target.includes(search)) {
            return 100;
        }
        
        // Calculate Levenshtein distance
        const matrix = [];
        for (let i = 0; i <= search.length; i++) {
            matrix[i] = [i];
        }
        for (let j = 0; j <= target.length; j++) {
            matrix[0][j] = j;
        }
        
        for (let i = 1; i <= search.length; i++) {
            for (let j = 1; j <= target.length; j++) {
                if (search[i - 1] === target[j - 1]) {
                    matrix[i][j] = matrix[i - 1][j - 1];
                } else {
                    matrix[i][j] = Math.min(
                        matrix[i - 1][j - 1] + 1,
                        matrix[i][j - 1] + 1,
                        matrix[i - 1][j] + 1
                    );
                }
            }
        }
        
        const distance = matrix[search.length][target.length];
        const maxLength = Math.max(search.length, target.length);
        const similarity = (maxLength - distance) / maxLength;
        
        return similarity * 100;
    }

    // Plant search functionality
    function initPlantSearch() {
        const searchContainer = document.querySelector('.c-plant-search');
        if (!searchContainer) return;

        const searchInput = searchContainer.querySelector('.c-plant-search__input');
        const resultsContainer = searchContainer.querySelector('.c-plant-search__results');
        const plantItems = document.querySelectorAll('.js-plant-item');
        
        let searchTimeout;
        let allPlants = [];

        // Collect all plant data
        plantItems.forEach(item => {
            const plantName = item.getAttribute('data-plant-name') || '';
            const botanicalName = item.getAttribute('data-plant-botanical') || '';
            
            allPlants.push({
                element: item,
                name: plantName,
                botanical: botanicalName,
                searchText: `${plantName} ${botanicalName}`.toLowerCase()
            });
        });

        // Search function
        function performSearch(searchTerm) {
            if (searchTerm.length < 3) {
                resultsContainer.innerHTML = '';
                resultsContainer.style.display = 'none';
                return;
            }

            const results = allPlants
                .map(plant => {
                    const nameScore = fuzzySearch(searchTerm, plant.name);
                    const botanicalScore = fuzzySearch(searchTerm, plant.botanical);
                    const searchTextScore = fuzzySearch(searchTerm, plant.searchText);
                    
                    const bestScore = Math.max(nameScore, botanicalScore, searchTextScore);
                    
                    return {
                        ...plant,
                        score: bestScore
                    };
                })
                .filter(plant => plant.score > 30) // Minimum similarity threshold
                .sort((a, b) => b.score - a.score)
                .slice(0, 5); // Max 5 results

            displayResults(results, searchTerm);
        }

        // Display search results
        function displayResults(results, searchTerm) {
            if (results.length === 0) {
                resultsContainer.innerHTML = '<div class="c-plant-search__no-results">Geen planten gevonden</div>';
                resultsContainer.style.display = 'block';
                return;
            }

            const resultsHTML = results.map(plant => {
                let displayName = plant.name;
                let displayBotanical = plant.botanical;
                
                // Highlight matching parts using fuzzy matching
                const nameScore = fuzzySearch(searchTerm, plant.name);
                const botanicalScore = fuzzySearch(searchTerm, plant.botanical);
                
                // If the score is high enough, highlight the best matching substring
                if (nameScore > 50) {
                    displayName = highlightBestMatch(plant.name, searchTerm);
                }
                
                if (botanicalScore > 50 && plant.botanical) {
                    displayBotanical = highlightBestMatch(plant.botanical, searchTerm);
                }

                return `
                    <div class="c-plant-search__result" data-plant-id="${plant.element.id || ''}">
                        <div class="c-plant-search__result-name">${displayName}</div>
                        ${plant.botanical ? `<div class="c-plant-search__result-botanical">${displayBotanical}</div>` : ''}
                    </div>
                `;
            }).join('');

            resultsContainer.innerHTML = resultsHTML;
            resultsContainer.style.display = 'block';
        }

        // Function to highlight the best matching substring
        function highlightBestMatch(text, searchTerm) {
            if (!text || !searchTerm) return text;
            
            const search = searchTerm.toLowerCase();
            const target = text.toLowerCase();
            
            // Try to find the best matching substring
            let bestMatch = '';
            let bestScore = 0;
            
            // Check for exact substring matches first
            if (target.includes(search)) {
                const regex = new RegExp(`(${searchTerm})`, 'gi');
                return text.replace(regex, '<mark>$1</mark>');
            }
            
            // For fuzzy matches, find the best substring
            for (let i = 0; i <= target.length - search.length; i++) {
                const substring = target.substr(i, search.length);
                const score = fuzzySearch(search, substring);
                if (score > bestScore) {
                    bestScore = score;
                    bestMatch = text.substr(i, search.length);
                }
            }
            
            // Also check for partial matches at word boundaries
            const words = text.split(/\s+/);
            for (let word of words) {
                const wordScore = fuzzySearch(search, word.toLowerCase());
                if (wordScore > bestScore) {
                    bestScore = wordScore;
                    bestMatch = word;
                }
            }
            
            // If we found a good match, highlight it
            if (bestScore > 60 && bestMatch) {
                const regex = new RegExp(`(${bestMatch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
                return text.replace(regex, '<mark>$1</mark>');
            }
            
            return text;
        }

        // Handle search input
        searchInput.addEventListener('input', function() {
            const searchTerm = this.value.trim();
            
            clearTimeout(searchTimeout);
            searchTimeout = setTimeout(() => {
                performSearch(searchTerm);
            }, 300); // Debounce search
        });

        // Handle result clicks
        resultsContainer.addEventListener('click', function(e) {
            const resultItem = e.target.closest('.c-plant-search__result');
            if (!resultItem) return;

            const plantId = resultItem.getAttribute('data-plant-id');
            const plantElement = document.getElementById(plantId) || 
                               allPlants.find(plant => plant.element.id === plantId)?.element;

            if (plantElement) {
                // Remove previous highlights
                document.querySelectorAll('.c-plant-item--highlighted').forEach(item => {
                    item.classList.remove('c-plant-item--highlighted');
                });

                // Scroll to plant
                plantElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });

                // Highlight the plant
                plantElement.classList.add('c-plant-item--highlighted');

                // Clear search
                searchInput.value = '';
                resultsContainer.style.display = 'none';
            }
        });

        // Close results when clicking outside
        document.addEventListener('click', function(e) {
            if (!searchContainer.contains(e.target)) {
                resultsContainer.style.display = 'none';
            }
        });

        // Handle keyboard navigation
        searchInput.addEventListener('keydown', function(e) {
            const results = resultsContainer.querySelectorAll('.c-plant-search__result');
            const activeResult = resultsContainer.querySelector('.c-plant-search__result--active');
            
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (!activeResult) {
                    results[0]?.classList.add('c-plant-search__result--active');
                } else {
                    const currentIndex = Array.from(results).indexOf(activeResult);
                    const nextIndex = (currentIndex + 1) % results.length;
                    activeResult.classList.remove('c-plant-search__result--active');
                    results[nextIndex]?.classList.add('c-plant-search__result--active');
                }
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                if (activeResult) {
                    const currentIndex = Array.from(results).indexOf(activeResult);
                    const prevIndex = currentIndex === 0 ? results.length - 1 : currentIndex - 1;
                    activeResult.classList.remove('c-plant-search__result--active');
                    results[prevIndex]?.classList.add('c-plant-search__result--active');
                }
            } else if (e.key === 'Enter') {
                e.preventDefault();
                const activeResult = resultsContainer.querySelector('.c-plant-search__result--active');
                if (activeResult) {
                    activeResult.click();
                }
            } else if (e.key === 'Escape') {
                resultsContainer.style.display = 'none';
                searchInput.blur();
            }
        });
    }

    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPlantSearch);
    } else {
        initPlantSearch();
    }

})();
